import React from 'react';

/** Always dark mode — no toggle. */
export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};
